/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_BarInputs */

const en_svc_n8n_art_bar = /** @type {(inputs: Svc_N8n_Art_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow runs today`)
};

const lv_svc_n8n_art_bar = /** @type {(inputs: Svc_N8n_Art_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šodienas darba plūsmu izpildes`)
};

/**
* | output |
* | --- |
* | "Workflow runs today" |
*
* @param {Svc_N8n_Art_BarInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_bar = /** @type {((inputs?: Svc_N8n_Art_BarInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_BarInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_bar(inputs)
	return en_svc_n8n_art_bar(inputs)
});